import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import { connect } from 'formik'

function FastCheckbox(props: any) {
  return <Checkbox {...props} />
}

export default connect(FastCheckbox)
